import { recipesService } from "../../services/recipes.service"

export async function homeLoader() {
    return { recipeIds: await recipesService.getIds() }
}